<template>
  <span id="add-layout" v-if="this.$can(this.permissions.WAREHOUSE.EDIT_LAYOUTS)">
    <el-button
      id="btn-add-layout"
      type="success"
      size="mini"
      plain
      @click="dialogVisible = true"
    >{{ $t('layout.addLayout') }}</el-button>
    <el-dialog
      width="65%"
      class="dialog-with-cols"
      :close-on-click-modal="false"
      :title="$t('layout.addLayout')"
      :visible.sync="dialogVisible"
      @close="handleClose()"
      @open="handleOpen()"
    >
      <el-form :model="form" :rules="formRules" ref="form" label-position="top" size="mini">
        <el-row>
          <el-col :md="8" :xs="12" class="form-vertical-item">
            <el-form-item
              class="inline-input"
              :label="$t('layout.warehouse')"
            >
              <el-input class="inline-input" disabled :value="user.warehouseCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :xs="12" class="form-vertical-item">
            <el-form-item :label="$t('layout.date')" prop="layoutDate" class="inline-input">
              <el-date-picker
                class="el-dropdown-new drop-sp date-dob"
                v-model="form.layoutDate"
                format="MM/dd/yyyy"
                type="date"
                :picker-options="layoutDatePickerOptions"
                :clearable="false"
                @change="handleSearch()"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :md="8" :xs="12" class="form-vertical-item">
            <el-form-item :label="$t('layout.layoutTemplate')" prop="parentLayoutTemplateId" ref="parentLayoutTemplateId">
              <el-select
                v-model="form.parentLayoutTemplateId"
                :no-data-text="noTemplateForDayMessage"
              >
                <el-option
                  v-for="item in layoutTemplates"
                  :key="item.id"
                  :label="item.dayName + ' - ' + item.code + ' - ' + item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div id="add-dialog-footer" class="dialog-footer form-vertical-item flex-reverse-direction" slot="footer">
        <el-button
          id="form-save-button"
          type="primary"
          size="mini"
          @click="submitForm()"
        >{{ $t('layout.addLayout') }}</el-button>
        <el-button
          id="form-cancel-button"
          size="mini"
          @click="resetForm()"
        >{{ $t('common.clear') }}</el-button>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import { Message } from 'element-ui';
import layoutTemplateService from '@/api/layoutTemplateService';
import constants from '@/utils/constants';

export default {
  computed: {
    ...mapGetters([
      'user'
    ]),
    noTemplateForDayMessage() {
      const day = moment(this.form.layoutDate.getTime()).day();
      const dayName = constants.DAYS_OPTIONS.find(option => option.value === day.toString()).label;
      return this.$t('layout.noTemplateForDay').concat(dayName);
    }
  },
  data() {
    return {
      dialogVisible: false,
      layoutDatePickerOptions: {
        disabledDate(time) {
          return moment(time.getTime()).isBefore(Date.now(), 'day');
        }
      },
      layoutTemplates: [],
      form: {
        warehouseId: null,
        layoutDate: new Date(),
        parentLayoutTemplateId: null
      },
      formRules: {
        layoutDate: [
          { required: true, message: this.$t('layout.error.layoutDateRequired'), trigger: 'blur' }
        ],
        parentLayoutTemplateId: [
          { required: true, message: this.$t('layout.error.layoutTemplateRequired'), trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    handleOpen() {
      this.$nextTick(() => {
        this.resetForm();
      });
    },
    handleClose() {
      this.$store.dispatch('layout/search', {});
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.form.warehouseId = this.user.warehouseId;
      this.form.layoutDate = new Date();
      this.handleSearch();
    },
    async handleSearch() {
      this.$refs.parentLayoutTemplateId.resetField();
      this.parentLayoutTemplateId = null;
      const day = moment(this.form.layoutDate.getTime()).day();
      const response = await layoutTemplateService.search({ warehouseId: this.form.warehouseId, day });
      if (response && response.data) {
        this.layoutTemplates = response.data;
      }
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          Message.closeAll();
          const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
          try {
            const response = await this.$store.dispatch('layout/save', this.form);
            this.$message.success(response.message);
            this.resetForm();
          } finally {
            loading.close();
          }
        }
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#add-layout {
  .el-select, .el-date-editor {
    width: 100%;
  }
}
</style>
